import { Pipe, PipeTransform } from '@angular/core';
import Constants from '../shared/constants';
import * as moment from 'moment';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
    transform(value: string, args: string[]): any {
        if (!value) { return value; }
        return moment(value).format(Constants.MomentDateFormat);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/date-format.pipe.ts